import {
    FETCH_ALL_USER_SUCCESS, 
    EDIT_USER, 
    UPDATE_USER_SUCCESS, 
    CREATE_USER_SUCCESS, 
    DELETE_USER_SUCCESS,
    SET_USER,
    SET_ROLE,
    VERIFY_EMAIL_SUCCESS,
    SET_PASSWORD_SUCCESS,
} from "constants/users.constants";

const INIT_STATE = {
    users: [],
    user_roles:[],
    user: {
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        phone_no: '',
        address: '',
        dob: '',
        country:null,
        gender:''
    },
    emailVarified: false,
    setPasswordStatus: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.user);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                user:c
            }
        }
        //set user
        case SET_USER: {
            let c = Object.assign({}, state.user);
            c[action.key] = action.value
            return {
                ...state,
                user: c
            }
        }
        case FETCH_ALL_USER_SUCCESS: {
            return {
                ...state,
                users: action.payload.users,
                pagination: action.payload.page
            }
        }

        case UPDATE_USER_SUCCESS: {
            let foundIndex = state.users.findIndex(x => x.id === action.payload.user.id);
            let all = Object.assign([], state.users);
            let o =  action.payload.user
            all[foundIndex] = o
            return {
                ...state,
                users: all,
                user: o,
            }
        }

        case CREATE_USER_SUCCESS: {
            let all = Object.assign([], state.users);
            all.push(action.payload.data)
            return {
                ...state,
                users: all,
                user: INIT_STATE.user
            }
        }

        case DELETE_USER_SUCCESS: {
            let all = Object.assign([], state.users);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                users: newArray,
            }
        }

        case EDIT_USER: {
            let u = state.users.find(c => c.id === action.payload)
            let o = Object.assign({}, u)
        
           // o.country_id = o.country.id
           // o.user_type_id = o.partner_type.id
            return {
                ...state,
                user: o
            }
        }

        case VERIFY_EMAIL_SUCCESS: {
            return {
                ...state,
                emailVarified: true
            }
        }

        case SET_PASSWORD_SUCCESS: {
            return {
                ...state,
                setPasswordStatus: true
            }
        }
        
        default:
            return state;
    }
}